<div class="contract-sections-container">
  <!-- Breadcrumb -->
  <nav class="mb-4" aria-label="Breadcrumb">
    <p-breadcrumb 
      styleClass="custom-breadcrumb"
      [model]="breadcrumbItems()" 
      [home]="{icon: 'pi pi-home', routerLink: '/axa/professionals-dashboard'}">
    </p-breadcrumb>
  </nav>

  <!-- Page Header -->
  <section class="page-header" aria-labelledby="page-title">
    <div class="header-content">
      <div class="header-left">
        <i class="pi pi-list header-icon" aria-hidden="true"></i>
        <div class="header-text">
          <h1 id="page-title">Gestione Blocchi di Testo</h1>
          <p class="subtitle">Crea e gestisci i blocchi di testo riutilizzabili nei contratti</p>
        </div>
      </div>
    </div>
  </section>

  <!-- Reusable Table Component -->
  <app-registry-table
    [title]="tableTitle"
    [icon]="tableIcon"
    [columns]="columns"
    [data]="data()"
    [loading]="loading()"
    [showClearFiltersButton]="true"
    [ignoreStatusChecks]="true"
    (onDetailClick)="onDetailClick($event)"
    (onEditClick)="onEditClick($event)"
    (onDuplicateClick)="onDuplicateClick($event)"
    (onDeleteClick)="onDeleteClick($event)"
    (onClearFilters)="onClearFilters()"
  />

  <!-- Preview Dialog -->
  <p-dialog
    [(visible)]="previewVisible"
    [modal]="true"
    [style]="{ width: '70vw' }"
    [draggable]="false"
    [resizable]="false"
    [header]="previewData()?.title || 'Anteprima'"
    aria-modal="true"
    [ariaLabel]="previewData()?.title || 'Anteprima blocco di testo'"
    [contentStyle]="{ overflow: 'auto' }"
  >
    <div
      class="preview-content"
      [innerHTML]="previewData()?.content"
      role="document"
      aria-label="Contenuto anteprima blocco di testo"
    ></div>

    <ng-template pTemplate="footer">
      <p-button
        label="Chiudi"
        (onClick)="closePreview()"
        [variant]="'outlined'"
        ariaLabel="Chiudi finestra anteprima"
        [attr.title]="'Chiudi finestra anteprima'"
      ></p-button>
    </ng-template>
  </p-dialog>

  <!-- Toast for notifications -->
  <p-toast position="top-right" role="status" aria-live="polite" aria-atomic="true" />

  <!-- Confirm Dialog for delete actions -->
  <p-confirmDialog role="alertdialog" aria-modal="true" />
</div>
